import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import runAsync from '@/script/runAsync.mjs'
import http from '@/biz/http.mjs'

export const readProject = ({prjId}) => http.get(`/prjs/${prjId}/info`)
export const readProjects = args => http.get('/prjs', args)

export const useProject = prjId => useSwrNoCache(
    () => runAsync(
        () => readProject({prjId}),
        {action: '读取项目'},
    ),

    {
        dependencies: [prjId],
        start: void 0 !== prjId,
    }
)

export const useProjects = args => useSwrNoCache(
    () => runAsync(
        () => readProjects(args),
        {action: '读取项目列表'},
    )
)
